import {
  TaskTrackerProject,
  TaskTrackerProjectDetails,
  TaskTrackerProjectMember,
  TaskTrackerProjectRole,
} from '../store/taskTracker.types'
import {
  ApiBoard,
  ApiProjectDetails,
  ApiProjectMember,
  ApiProjectRole,
  ApiProjectSummary,
} from './taskTracker.api.types'
import {
  mapBoardFromApi,
  sortBoardsByPosition,
} from './taskTracker.boards.api.mappers'

const mapProjectCurrentUserRoleTypeFromApi = (
  value: ApiProjectSummary['current_user_role_type'],
): TaskTrackerProject['currentUserRoleType'] => {
  if (value === 'admin' || value === 'employee') return value
  return null
}

export const mapProjectFromApi = (
  item: ApiProjectSummary & { board?: ApiBoard },
): TaskTrackerProject => {
  const boardsSource = item.boards ?? (item.board ? [item.board] : [])

  return {
    id: Number(item.id),
    title: String(item.title ?? '').trim(),
    creatorId:
      item.creator_id !== null && item.creator_id !== undefined
        ? Number(item.creator_id)
        : null,
    position: Number(item.position ?? 0),
    currentUserRoleType: mapProjectCurrentUserRoleTypeFromApi(
      item.current_user_role_type,
    ),
    boards: sortBoardsByPosition(boardsSource.map(mapBoardFromApi)),
  }
}

export const mapRoleFromApi = (
  item: ApiProjectRole,
): TaskTrackerProjectRole => ({
  id: Number(item.id),
  projectId: Number(item.project_id),
  title: String(item.title ?? ''),
  isSystem: Boolean(item.is_system),
  permissions: Array.isArray(item.permissions)
    ? item.permissions.map(String)
    : [],
})

export const mapMemberFromApi = (
  item: ApiProjectMember,
): TaskTrackerProjectMember => ({
  id: Number(item.id),
  projectId: Number(item.project_id),
  userId: Number(item.user_id),
  roleId: Number(item.role_id),
  user: item.user
    ? {
        id: Number(item.user.id),
        name: String(item.user.name ?? ''),
        email: item.user.email ?? null,
        phone: item.user.phone ?? null,
        avatarPath: item.user.avatar_path ?? null,
      }
    : null,
  role: item.role ? mapRoleFromApi(item.role) : null,
})

export const mapProjectDetailsFromApi = (
  item: ApiProjectDetails,
): TaskTrackerProjectDetails => ({
  ...mapProjectFromApi(item),
  board: mapBoardFromApi(
    item.board ?? item.boards?.[0] ?? { id: 0, project_id: item.id, title: '' },
  ),
  roles: (item.roles ?? []).map(mapRoleFromApi),
  members: (item.members ?? []).map(mapMemberFromApi),
})
